module.exports = __webpack_public_path__ + "static/media/loadingsimg.eaef229c.png";